import {ModelApi} from '@/api/model.api.js'

/**
 * Timezones API service
 */
export class TimezonesApi extends ModelApi {

  //Props
  basePath = '/api/v1/timezones'
  itemsKey = 'timezones'
}

//Export singleton instance
export const timezonesApi = new TimezonesApi()
